import { ProductReference } from '../../core/api/products/entities/product-reference.entity';
import { ProductFormControls } from '../form-controls/product.form-controls';
import { ProductFormOptions } from '../form-options/product.form-options';
import { BaseForm } from './base.form';

export class ProductForm extends BaseForm<ProductFormControls> {
  barcodeExists = false;
  formGroup = this.createFormGroup(ProductFormControls);
  override options = new ProductFormOptions();

  get barcode(): string | null {
    return this.controls.barcode.value;
  }

  get inStockProductOptions(): ProductReference[] {
    return this.options.products.filter(product => product.inStock);
  }

  override clear(): void {
    super.clear();
    this.barcodeExists = false;
  }

  disable(): void {
    this.controls.barcode.disable();
    this.controls.product.disable();
  }

  enable(): void {
    this.controls.barcode.enable();
    this.controls.product.enable();
  }
}
